module.exports = __webpack_public_path__ + "static/homeschool-bg-47198e57ca79ff7f6cb5c8aeb5164ba0.jpg";